var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dark-green",attrs:{"id":"footer"}},[_c('p',[_vm._v("© 2021 Reena’s Jade Massage Therapy. All rights reserved.")])])}]

export { render, staticRenderFns }